import {
  systemCiBuildControllerQueueDepth,
  systemCiBuildControllerCurrent,
  systemCiBuildControllerBrands,
  systemCiBuildControllerBuild,
  systemCiBuildControllerRelease,
  systemCiBuildControllerPurge,
} from "../../api/generated";

// White-label build console — SYSTEM_ADMIN only. Talks to progress-server's
// SystemCIBuildController (/system/ci-build/*), which enqueues jobs onto the SQS
// build queue (the Mac worker fleet consumes them) and serves status.
//
// Migrated to the OpenAPI-generated client: auth + timezone come from configureApi's
// interceptor (per-call token reads removed). These endpoints return plain objects/arrays
// UN-enveloped, so `data` == the old axios `response.data`; each function returns {data} so
// callers keep reading `res.data`.

// Queue depth (pending + in-flight jobs).
export const getQueueDepth = async () => {
  const {data, error} = await systemCiBuildControllerQueueDepth();
  if (error) throw error;
  return {data};
};

// Latest build status per brand × platform (success / failed / in-progress + version + when).
export const getCurrentStatus = async () => {
  const {data, error} = await systemCiBuildControllerCurrent();
  if (error) throw error;
  return {data};
};

// All known white-label brands (for the brand selector).
export const getBrands = async () => {
  const {data, error} = await systemCiBuildControllerBrands();
  if (error) throw error;
  return {data};
};

// Trigger a BUILD. brands omitted/empty => all enabled; platform = ios|android|both.
// Build = TestFlight + Play Internal (no store review).
/** @param {{brands?: string[]|null, platform?: string}} [opts] */
export const triggerBuild = async ({brands = null, platform = "both"} = {}) => {
  const query = {};
  if (Array.isArray(brands) && brands.length) query.brands = brands;
  if (platform) query.platform = platform;
  const {data, error} = await systemCiBuildControllerBuild({query});
  if (error) throw error;
  return {data};
};

// Trigger a RELEASE (publish). Same params as build. Release submits the brand
// for store review: iOS submit_for_review, Android submit_to_production.
/** @param {{brands?: string[]|null, platform?: string}} [opts] */
export const triggerRelease = async ({brands = null, platform = "both"} = {}) => {
  const query = {};
  if (Array.isArray(brands) && brands.length) query.brands = brands;
  if (platform) query.platform = platform;
  const {data, error} = await systemCiBuildControllerRelease({query});
  if (error) throw error;
  return {data};
};

// Clear all PENDING jobs from the queue.
export const purgeQueue = async () => {
  const {data, error} = await systemCiBuildControllerPurge();
  if (error) throw error;
  return {data};
};
